import * as server from '../entries/pages/dashboard/card/_page.server.js';

export const index = 4;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/dashboard/card/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/dashboard/card/+page.server.js";
export const imports = ["_app/immutable/nodes/4.DnmTodyc.js","_app/immutable/chunks/cL9VaPgy.js","_app/immutable/chunks/C75YQU_W.js","_app/immutable/chunks/D1kbsK6n.js","_app/immutable/chunks/BAJkae7J.js","_app/immutable/chunks/Cz-4yBSw.js","_app/immutable/chunks/Wy6oXzdU.js","_app/immutable/chunks/B4FYT0oR.js","_app/immutable/chunks/D-5ps19L.js","_app/immutable/chunks/BGk0RnQK.js"];
export const stylesheets = [];
export const fonts = [];
